var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 128c-44.1 0-80 35.9-80 80v256c0 8.8 7.2 16 16 16s16-7.2 16-16v-256c0-26.5 21.5-48 48-48 26.5 0 48 21.5 48 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-35.9-80-80-80z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 192c-8.8 0-16 7.2-16 16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144c0-8.8-7.2-16-16-16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 400c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m320 256c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16v-192c0-8.8-7.2-16-16-16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m128 288c-8.8 0-16 7.2-16 16v112c0 8.8 7.2 16 16 16s16-7.2 16-16v-112c0-8.8-7.2-16-16-16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m448 256c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m368.7 145.2c-8.2 3.3-12.1 12.6-8.8 20.8 5.4 13.3 8.1 27.4 8.1 42v208c0 8.8 7.2 16 16 16s16-7.2 16-16v-208c0-18.7-3.5-36.8-10.5-54-3.3-8.2-12.6-12.1-20.8-8.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256 64c-79.4 0-144 64.6-144 144v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-61.8 50.2-112 112-112 25.8 0 50 8.5 70.1 24.6 6.9 5.5 17 4.4 22.5-2.5 5.5-6.9 4.4-17-2.5-22.5C320.7 75.2 288.7 64 256 64z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m185.5 46.7c22.3-9.7 46-14.7 70.5-14.7 97 0 176 79 176 176 0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.7-93.3-208-208-208-28.9 0-56.9 5.8-83.3 17.3-8.1 3.5-11.8 13-8.3 21.1 3.6 8.1 13 11.8 21.1 8.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m123.6 68.1c-6.6-5.9-16.7-5.3-22.6 1.3-34.2 38.2-53 87.4-53 138.7v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144c0-43.4 15.9-85 44.8-117.3 5.9-6.6 5.3-16.7-1.2-22.6z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.0894f0f14d02aea1959fd66c166d2eb8.svg";
export { ForwardRef as ReactComponent };